import React from "react";
import { useIsMobile } from "./useIsMobile";

export function Card({
  children,
  padded = true,
  padding,
  onClick,
  className,
  style,
  as: Tag = "div",
}) {
  const isMobile = useIsMobile();
  // Si el caller pasa `padding` explícito lo respetamos. Si no, el
  // default desktop es 20 y mobile es 16 — buscamos densidad en
  // pantallas pequeñas sin sacrificar legibilidad.
  const defaultPad = isMobile ? 16 : 20;
  const pad = padded ? (padding ?? defaultPad) : 0;
  return (
    <Tag
      onClick={onClick}
      className={className}
      style={{
        background: "var(--kr-bg-surface)",
        border: "1px solid var(--kr-border)",
        borderRadius: "var(--kr-radius-lg)",
        boxShadow: "var(--kr-shadow-xs)",
        padding: pad,
        cursor: onClick ? "pointer" : "default",
        ...(style || {}),
      }}
    >
      {children}
    </Tag>
  );
}

export default Card;
